import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import PresignedAvatar from '../../../components/common/PresignedAvatar';

const MAX_VISIBLE = 5;

const firstName = (name) => {
  const trimmed = String(name || '').trim();
  if (!trimmed) return 'User';
  return trimmed.split(/\s+/)[0];
};

const ParticipantAvatarRow = ({ participants = [], currentUserId, maxVisible = MAX_VISIBLE }) => {
  const directoryUsers = useSelector((state) => state.users?.users || []);

  const people = useMemo(() => {
    const byId = new Map((directoryUsers || []).map((user) => [String(user.id), user]));
    const list = (participants || []).filter((p) => p?.userId);
    const me = list.filter((p) => String(p.userId) === String(currentUserId));
    const rest = list.filter((p) => String(p.userId) !== String(currentUserId));
    return [...me, ...rest].map((p) => {
      const user = byId.get(String(p.userId));
      return {
        userId: p.userId,
        userName: p.userName || user?.firstName || user?.username || 'User',
        profilePicture: p.profilePicture || user?.profilePicture || null,
        cacheKey: user?.username || p.userId,
      };
    });
  }, [participants, directoryUsers, currentUserId]);

  if (!people.length) return null;

  const visible = people.slice(0, maxVisible);
  const hidden = people.length - visible.length;

  return (
    <div className="rounded-xl border border-gray-100 dark:border-gray-700 px-3 py-2.5">
      <p className="text-[10px] font-bold uppercase tracking-wide text-gray-400 mb-2">Participants</p>
      <div className="flex items-center min-w-0 overflow-hidden">
        <div className="flex items-center -space-x-2 flex-shrink-0">
          {visible.map((person, index) => (
            <div
              key={person.userId}
              className="relative"
              style={{ zIndex: visible.length - index }}
              title={person.userName}
            >
              <PresignedAvatar
                fileKey={person.profilePicture}
                cacheKey={person.cacheKey}
                name={person.userName}
                initials={firstName(person.userName).charAt(0)}
                className="w-10 h-10 rounded-full border-2 border-white dark:border-gray-900 object-cover"
                fallbackClassName="flex items-center justify-center bg-gradient-to-br from-sky-400 to-violet-500 text-white text-sm font-bold"
              />
            </div>
          ))}
        </div>
        {hidden > 0 && (
          <span className="ml-2.5 text-sm font-semibold text-gray-500 dark:text-gray-400 whitespace-nowrap">
            + {hidden} more
          </span>
        )}
      </div>
    </div>
  );
};

export default ParticipantAvatarRow;
